/**
 * Alert Types
 *
 * Type definitions for the alert system.
 * Used for user-configurable notifications based on account balances and operations.
 *
 * @module types/alert
 */
/**
 * Human-readable labels for alert types (for UI)
 */
export const ALERT_TYPE_LABELS = {
    balance: { fr: 'Solde actuel', en: 'Current balance' },
    forecast_balance: { fr: 'Solde prévisionnel (fin de mois)', en: 'Forecast balance (end of month)' },
    operation_amount: { fr: 'Montant d\'opération', en: 'Operation amount' },
};
/**
 * Human-readable labels for alert operators (for UI)
 */
export const ALERT_OPERATOR_LABELS = {
    lt: { fr: 'inférieur à', en: 'less than' },
    gt: { fr: 'supérieur à', en: 'greater than' },
    lte: { fr: 'inférieur ou égal à', en: 'less than or equal to' },
    gte: { fr: 'supérieur ou égal à', en: 'greater than or equal to' },
};
/**
 * Human-readable labels for alert directions (for UI)
 */
export const ALERT_DIRECTION_LABELS = {
    debit: { fr: 'Débit (dépense)', en: 'Debit (expense)' },
    credit: { fr: 'Crédit (revenu)', en: 'Credit (income)' },
    both: { fr: 'Les deux', en: 'Both' },
};
//# sourceMappingURL=alert.js.map